module.exports = __webpack_public_path__ + "static/img/stay-option-icon-drier.d5c45221.svg";